var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentUser)?_c('h3',{staticClass:"text-h3"},[_vm._v(" Welcome in, "+_vm._s(_vm.currentUser.first_name)+" ")]):_vm._e(),(_vm.stats)?_c('div',[_c('h4',{staticClass:"text-subtitle-1"},[_vm._v("Here are some basic stats:")]),_c('pre',[_vm._v(_vm._s(_vm.stats)+"\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }